import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

const Wrapper = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 14px;
  padding: 0 0 0 20px;
  margin: 17px 0 0;
`;

const Item = styled.li`
  list-style: none;
  color: #666;

  &:after {
    content: '/';
    color: #888;
    margin: 0 6px;
  }

  &:last-child {
    &:after {
      display: none;
    }
  }
`;

const Link = styled.a`
  color: ${p => p.theme.primary600};
  text-decoration: underline;
`;

export default function Breadcrumbs({ items }) {
  const itemListElement = items.map((item, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: `https://sayi.do/${item.href}`,
    };
  });
  const structuredJSON = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: itemListElement,
  };
  return (
    <div>
      <Wrapper>
        {items.map((item, index) => {
          return (
            <Item key={index}>
              {item.href ? (
                <Link href={item.href}>{item.label}</Link>
              ) : (
                item.label
              )}
            </Item>
          );
        })}
      </Wrapper>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredJSON)}
        </script>
      </Helmet>
    </div>
  );
}
